import { Navigate, useNavigate } from "react-router-dom";

import { ResourceState } from "../../shared/ui/resource-state.js";
import { useTickers } from "./queries.js";
import { TickerSymbolPicker } from "./ticker-symbol-picker.js";

export function TickersPage() {
  const navigate = useNavigate();
  const tickers = useTickers();
  if (tickers.isLoading)
    return (
      <ResourceState
        kind="loading"
        title="Opening symbol workspace"
        description="Reading stock symbols used by your Bots."
      />
    );
  const first = tickers.data?.[0];
  if (first === undefined)
    return (
      <section className="page-stack" aria-label="Open ticker">
        <h1>Tickers</h1>
        <div className="content-card section-stack">
          <h2>Open a stock chart</h2>
          <p>Type a symbol to view its live chart, even if you have no Bot for it.</p>
          {tickers.error === null ? null : (
            <ResourceState
              kind="degraded"
              title="Suggested symbols unavailable"
              description="You can still enter a symbol."
            />
          )}
          <TickerSymbolPicker
            symbol=""
            suggestions={[]}
            onOpen={(symbol) => void navigate(`/tickers/${encodeURIComponent(symbol)}?view=live`)}
          />
        </div>
      </section>
    );
  return <Navigate replace to={`/tickers/${encodeURIComponent(first.symbol)}`} />;
}
